import { Link } from 'react-router-dom';
import { RouteNames } from './AppRouter';

/**
 * Fil d'Ariane des pages d'administration.
 *
 * L'élément courant est un span et non un lien : il ne mène nulle part, et
 * jsx-a11y/anchor-is-valid fait échouer le build sur un href invalide.
 */
function AdminBreadcrumb({ trail }) {
    return (
        <nav className="breadcrumb" aria-label="fil d'Ariane">
            <ul>
                <li><Link to={RouteNames.admin}>Administration</Link></li>
                {trail.map((etape, index) => {
                    const estCourant = index === trail.length - 1;

                    return (
                        <li key={etape.libelle} className={estCourant ? 'is-active' : ''}>
                            {estCourant || !etape.to
                                ? <span aria-current={estCourant ? 'page' : undefined}>{etape.libelle}</span>
                                : <Link to={etape.to}>{etape.libelle}</Link>}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

export default AdminBreadcrumb;
